export default {
  "noti.title": "お知らせ",
  "noti.detailLink": "すべて見る",
};